import styled from 'styled-components';

import { colors } from 'ui/theme';

interface IdDisplayProps {
  id: number;
}

const IdWrapper = styled.span`
  color: ${colors.textSecondary};
`;

export const IdDisplay = ({ id }: IdDisplayProps) => <IdWrapper>{` (ID: ${id})`}</IdWrapper>;
